import * as R from "ramda";
import { AnimatedSpriteWrap } from "./pixi/animatedSprite";
export function animation(pixiContext, sheets, fileName) {
    const textures = animationTextures(sheets, fileName);
    return new AnimatedSpriteWrap(pixiContext, textures);
}
export function animationTextures(sheets, fileName) {
    let textures = [];
    for (const sheet of sheets) {
        if (sheet.hasAnimation(fileName)) {
            textures = textures.concat(sheet.animationTexturesWithName(fileName));
        }
    }
    const sorted = R.sortBy((x) => x[0], textures);
    return R.map(([, texture]) => texture, sorted);
}
export function sprite(sheets, fileName) {
    const sprites = R.chain((sheet) => sheet.sprites([fileName]), sheets);
    return sprites[0];
}
export const Sheets = {
    animation,
    animationTextures,
    sprite,
};
//# sourceMappingURL=sheets.js.map